import React, { memo } from 'react';
import { styled } from '@compiled/react';
import ShipIcon from '@atlaskit/icon/glyph/ship';
import { token } from '@atlaskit/tokens';

type Props = {
	size?: 'small' | 'medium';
};

const ReleaseIcon = ({ size = 'medium' }: Props) => (
	<Wrapper iconSize={size}>
		<ShipIcon label="" size={size} />
	</Wrapper>
);

export default memo(ReleaseIcon);

const SMALL_ICON_SIZE = 16;
const MEDIUM_ICON_SIZE = 24;

type IconSize = 'small' | 'medium';

const getIconSize = ({ iconSize }: { iconSize: IconSize }) =>
	iconSize === 'small' ? SMALL_ICON_SIZE : MEDIUM_ICON_SIZE;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div<{ iconSize: IconSize }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${getIconSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${getIconSize}px`,
	marginRight: token('space.050', '4px'),
	lineHeight: 1,
});
